import React from 'react';
import { HomeIcon, ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/24/solid';
import { Channel } from 'shared/types/channel';
import { useTranslations } from 'use-intl';
import Button from 'components/commercetools-ui/atoms/button';

export interface Props {
  channels: Array<Channel>;
  detailChannel?: Channel;
  openDetailsFor: (channel: Channel) => void;
  closeDetails: () => void;
  setSelectedChannel: (channel: Channel | undefined) => void;
  selectedChannel?: Channel;
}

const StoresList: React.FC<Props> = ({
  channels,
  detailChannel,
  openDetailsFor,
  closeDetails,
  setSelectedChannel,
  selectedChannel,
}) => {
  
  const translate = useTranslations();

  return (
    <>
      {!detailChannel && (
        <div className="py-10">
          <div className="mb-4 px-10 py-20 text-2xl font-bold">{translate('channel.find-channel')}</div>
          <div>
            {channels.map((channel, index) => {
              const className = 'p-15 cursor-pointer flex ' + (index % 2 === 0 ? 'bg-gray-200' : 'bg-white');

              const address = channel?.address;
              return (
                <div
                  className={className}
                  onClick={() => {
                    openDetailsFor(channel);
                  }}
                  key={channel.channelId}
                >
                  <div>
                    <div className="mb-2 flex items-center text-xl font-bold">
                      {channel.name}
                      {channel.channelId === selectedChannel?.channelId && <HomeIcon className={'h-16 pl-3'} />}
                    </div>
                    <div className="text-base">
                      {address?.streetName} {address?.streetNumber}
                    </div>
                    <div className="text-base">
                      {address?.postalCode} {address?.city}
                    </div>
                  </div>

                  <div className="ml-auto grid place-items-center justify-self-end">
                    <ChevronRightIcon className="h-18" aria-hidden="true" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {detailChannel && (
        <div className="py-10">
          <div
            className="mb-4 flex cursor-pointer items-center px-10 text-2xl"
            onClick={() => {
              closeDetails();
            }}
          >
            <ChevronLeftIcon className="h-20" aria-hidden="true" />
            <div className="justify-self-end pl-5 font-light">{translate('channel.back')}</div>
          </div>
          <div className="p-15">
            <div className="mb-2 text-xl font-bold">{detailChannel.name}</div>
            <div className="text-base">
              {detailChannel.address?.streetName}{' '}
              {detailChannel.address?.streetNumber}
            </div>
            <div className="text-base">
              {detailChannel.address?.postalCode} {detailChannel.address?.city}
            </div>
            <div className="w-full pt-15">
              <Button
                variant="secondary"
                onClick={() => {
                  setSelectedChannel(detailChannel?.channelId === selectedChannel?.channelId ? undefined : detailChannel);
                }}
              >
                {detailChannel?.channelId === selectedChannel?.channelId
                  ? translate('channel.removeAsFavorite')
                  : translate('channel.markAsFavorite')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StoresList;
